import React from "react";
import { Wrapper, HeroWrapper, Title, RedText, HeroImage } from "./Hero.styled";

const Hero = () => (
  <Wrapper>
    <HeroWrapper>
      <Title>
        <h1>Happy Birthday</h1>
        <h2>
          My <RedText>Love</RedText>
        </h2>
      </Title>
      <HeroImage src="./Hero.png" alt="Hero image" />
    </HeroWrapper>
  </Wrapper>
);

export default Hero;
